import React, { useMemo } from 'react';
import CommonTable from '../../../../global/table';
import NoRecordFound from '../../../../global/noRecordFound';
import { formatDateTime, formatLeadSource } from '../../../../../utils/functions';

const EnhancedCancelledSubscriptionsList = ({
    isLoading,
    subscriptionList,
    sort,
    setSort
}) => {
    const getReasonTitle = (reason, otherReason) => {
        let reasons = "";
        if (reason.ChangedCancelledCRMSoftware === true)
            reasons = "Changed Cancelled CRM Software<br/>";
        if (reason.NoLongerUsing3rdPartyLeads === true)
            reasons += "No Longer Using 3rd Party Leads<br/>";
        if (reason.NotEnoughLeadsIncoming === true)
            reasons += "Not Enough Leads Incoming<br/>";
        if (reason.ServiceNotWorking === true)
            reasons += "Service Not Working<br/>";
        if (reason.TooComplicated === true) reasons += "Too Complicated<br/>";
        if (reason.TooExpensive === true) reasons += "Too Expensive<br/>";
        if (reason.Other === true) {
            reasons += `Other: ${otherReason}<br/>`;
        }
        return reasons;
    };

    const columns = [
        {
            title: "Cancelled By",
            dataIndex: "cancelledBy",
            key: "cancelledBy",
            sortType: "Cancelled By", // Assuming API supports this sort key, checking original: 'Cancelled By'
            render: (text) => <span className="capitalize">{text}</span>
        },
        {
            title: "Cancelled Reason",
            dataIndex: "cancelledReason",
            key: "cancelledReason",
            sortType: "Cancelled Reason",
            render: (text, record) => (
                <span
                    dangerouslySetInnerHTML={{
                        __html: getReasonTitle(
                            record.originalData?.cancelReasons || {},
                            record.originalData?.cancelReasonOther
                        ),
                    }}
                />
            ),
        },
        {
            title: "Cancelled At",
            dataIndex: "cancelledAt",
            key: "cancelledAt",
            sortType: "Cancelled At",
            render: (text) => formatDateTime(text)
        }
    ];

    const data = useMemo(() => {
        if (!subscriptionList || !subscriptionList.logs) return [];
        return subscriptionList.logs.map((item, idx) => ({
            key: item._id || idx,
            id: item._id || idx,
            cancelledBy: formatLeadSource(item?.userEmail),
            cancelledAt: item?.createdAt,
            originalData: item
        }));
    }, [subscriptionList]);

    if (!isLoading && (!data || data.length === 0)) {
        return <NoRecordFound message="No cancelled subscriptions found." />;
    }

    return (
        <CommonTable
            columns={columns}
            data={data}
            sort={sort}
            setSort={setSort}
        />
    );
};

export default EnhancedCancelledSubscriptionsList;
